import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Features from '../components/Features';
import QuickStats from '../components/QuickStats';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import FranchiseForm from '../components/FranchiseForm';

const Home: React.FC = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Aswad Amruttulya - Premium Tea Franchise | Best Masala Tea in India</title>
        <meta name="description" content="Aswad Amruttulya offers authentic premium tea with a unique taste. Explore our 10+ tea varieties and franchise opportunities across India." />
        <meta property="og:title" content="Aswad Amruttulya - Premium Tea Franchise" />
        <meta property="og:description" content="Serving authentic tea with a unique taste that lingers. 10+ products, 50+ outlets, 10K+ happy customers." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://aswadamruttulya.com/" />
      </Helmet>
      <Header />
      <Hero />
      <Features />
      <QuickStats />
      <Testimonials />
      <CTA />
      <FranchiseForm />
      <Footer />
    </div>
  );
};

export default Home;